import React, { ReactNode, useState } from 'react'
interface MaintenanceValue {
  maintenance: boolean
  setMaintenance: (maintenance: boolean) => void
}
export const Maintenance = React.createContext<MaintenanceValue>({
  maintenance: false,
  setMaintenance: () => null,
})
interface MaintenanceProviderProps {
  children: ReactNode
}
export const MaintenanceProvider: React.FC<MaintenanceProviderProps> = ({
  children,
}) => {
  const [maintenance, setMaintenance] = useState<boolean>(false)
  const contextValue: MaintenanceValue = {
    maintenance,
    setMaintenance,
  }
  return (
    <Maintenance.Provider value={contextValue}>{children}</Maintenance.Provider>
  )
}
